import { Route, Routes } from 'react-router-dom'
import SignIn from './pages/SignIn'
import UserProfile from './pages/user/UserProfile'
import EditProfile from './pages/user/EditProfile'
import { useSelector } from 'react-redux'
import UserTask from './pages/user/UserTask'
import Authorization from './pages/admin/Authorization'
import CreateAuthorization from './pages/admin/CreateAuthorization'
import Statistics from './pages/Statistics'
import SignUpUser from './pages/admin/SignUpUser'
import SignUpStore from './pages/admin/SignUpStore'
import UserManagement from './pages/admin/UserManagement'
import EditUser from './pages/admin/EditUser'
import StoreManagement from './pages/admin/StoreManagement'
import EditStore from './pages/admin/EditStore'
import ForgotPassword from './pages/ForgotPassword'
import ChangePassword from './pages/ChangePassword'
import UserManagementSM from './pages/storeManager/UserManagementSM'
import SignUpUserSM from './pages/storeManager/SignUpUserSM'
import EditUserSM from './pages/storeManager/EditUserSM.jsx'
import WorkManagement from './pages/admin/WorkManagement'
import AdminTask from './pages/admin/AdminTask'
import TagManagement from './pages/admin/TagManagement'
import TagByStore from './pages/admin/TagByStore'
import StatisticsAdmin from './pages/admin/StatisticsAdmin'
import StatisticsSM from './pages/storeManager/StatisticsSM'
import StatisticsByStore from './pages/admin/StatisticsByStore'
import 'chart.js/auto'
import EditAuthorization from './pages/admin/EditAuthorization'
import Search from './pages/Search'
import SearchDetail from './pages/SearchDetail'
import UserByStore from './pages/admin/UserByStore'
import AdminAccount from './pages/admin/AdminAccount'
import ScheduleOrderByStore from './pages/user/ScheduleOrderByStore'
import ScheduleOrderManagement from './pages/admin/ScheduleOrderManagement'
import StatisticsAdminToday from './pages/admin/StatisticsAdminToday'
import StatisticsSMToday from './pages/storeManager/StatisticsSMToday'
import StatisticsTodayByStore from './pages/admin/StatisticsTodayByStore'
import SearchTimerDetail from './pages/SearchTimerDetail'
import UserStatistics from './pages/admin/UserStatistics'
import SearchDeletedDetail from './pages/SearchDeletedDetail'
import StockManagement from './pages/admin/StockManagement'
import ImportExportHistory from './pages/admin/ImportExportHistory'
import ImportExportHistoryByStore from './pages/storeManager/ImportExportHistoryByStore'
import StockParameter from './pages/admin/StockParameter'
import StockParameterByStore from './pages/storeManager/StockParameterByStore'
import BookingForm from './pages/customer/BookingForm/BookingForm'
import GuestOrder from './pages/storeManager/GuestOrder'
import GuestOrderManagement from './pages/admin/GuestOrderManagement'
import GuestOrderByStore from './pages/admin/GuestOrderByStore'
import ViewStockHistory from './pages/storeManager/ViewStockHistory'
import StockManagementByStoreMultiPic from './pages/storeManager/StockManagementByStoreMultiPic'
import ProductStockMultiPic from './pages/storeManager/ProductStockMultiPic'
import ConfirmStockMultiPic from './pages/storeManager/ConfirmStockMultiPic'
import StockStatisticsByStoreSM from './pages/storeManager/StockStatisticsByStoreSM'
import StockStatistics from './pages/admin/StockStatistics'
import StockStatisticsByStore from './pages/admin/StockStatisticsByStore'
import ShippingService from './pages/storeManager/ShippingService'
import ShippingServiceOrder from './pages/storeManager/ShippingServiceOrder'
import StockForecast from './pages/admin/StockForecast'
import TransferOrderStatistics from './pages/storeManager/TransferOrderStatistics'
import UpdateTransferInfo from './pages/storeManager/UpdateTransferInfo'
import ImportExportHistoryByStoreByDate from './pages/storeManager/ImportExportHistoryByStoreByDate.jsx'
import CheckFreshStockHistory from './pages/storeManager/CheckFreshStockHistory.jsx'
import CheckProductStockHistory from './pages/storeManager/CheckProductStockHistory.jsx'
import BillManagement from './pages/admin/BillManagement.jsx'
import ImportStockBillByStore from './pages/admin/ImportStockBillByStore.jsx'
import StockBillDetailByStore from './pages/admin/StockBillDetailByStore.jsx'
import BillList from './pages/admin/BillList.jsx'
import BillDetail from './pages/admin/BillDetail.jsx'
import ZaloMiniApp from './pages/zaloMiniApp/index.jsx'
import WarehouseRouter from './pages/warehouseManagement/WarehouseRouter.jsx'
import Product from './pages/zaloMiniApp/Product'
import CreateProduct from './pages/zaloMiniApp/CreateProduct'
import Configuration from './pages/zaloMiniApp/Configuration'
import EditProduct from './pages/zaloMiniApp/EditProduct'
import StoreManagerOptions from './pages/storeManager/StoreManagerOptions'
import Customer from './pages/zaloMiniApp/Customer'
import CustomerDetail from './pages/zaloMiniApp/CustomerDetail'
import ZaloStatistics from './pages/zaloMiniApp/Statistics'
import ProductStockManagement from './pages/storeManager/ProductStockManagement'
import Orders from './pages/zaloMiniApp/Orders.jsx'
import OrderDetail from './pages/zaloMiniApp/OrderDetail'
import DetailProduct from './pages/zaloMiniApp/DetailProduct.jsx'
import SearchGuestDetail from './pages/SearchGuestDetail.jsx'
import CustomerHistoryPoints from './pages/zaloMiniApp/CustomerHistoryPoints.jsx'
import InternalSale from './pages/user/InternalSale.jsx'
import Cashflow from './pages/cashflow/Cashflow.jsx'
import { canAccessCashflow } from './utils/cashflowPermissions.js'

function App() {
	const { currentUser } = useSelector((state) => state.currentUser)

	return (
		<Routes>
			<Route
				path='/'
				element={
					currentUser.isLoggedIn ? (
						currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant' ? (
							<WorkManagement />
						) : (
							<UserTask />
						)
					) : (
						<SignIn />
					)
				}
			/>
			<Route path='/:storeId' element={<BookingForm />} />
			<Route path='/login' element={<SignIn />} />
			<Route path='/forgot-password' element={<ForgotPassword />} />
			<Route path='/change-password' element={currentUser.isLoggedIn ? <ChangePassword /> : <SignIn />} />

			<Route
				path='/admin/signup-user'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<SignUpUser />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/signup-store'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<SignUpStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/roles'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <Authorization /> : <SignIn />}
			/>
			<Route
				path='/admin/edit-authorization/:roleId'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <EditAuthorization /> : <SignIn />}
			/>
			<Route
				path='/admin/create-authorization'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <CreateAuthorization /> : <SignIn />}
			/>

			<Route
				path='/admin-account'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<AdminAccount />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/users'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<UserManagement />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/user/store/:storeId'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<UserByStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/edit-user/:userId'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<EditUser />
					) : (
						<SignIn />
					)
				}
			/>

			<Route
				path='/admin/task/store'
				element={
					currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') ? (
						<WorkManagement />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/task/store/:storeId'
				element={
					currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') ? (
						<AdminTask />
					) : (
						<SignIn />
					)
				}
			/>

			<Route
				path='/admin/stores'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<StoreManagement />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/edit-store/:storeId'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<EditStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/signup-store'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<SignUpStore />
					) : (
						<SignIn />
					)
				}
			/>

			<Route
				path='/admin/tags'
				element={
					currentUser.isLoggedIn && (currentUser.role === 'admin' || currentUser.role === 'director') ? (
						<TagManagement />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/tag/store/:storeId'
				element={currentUser.isLoggedIn && currentUser.permission?.includes('createTag') ? <TagByStore /> : <SignIn />}
			/>
			<Route
				path='/admin/statistics'
				element={
					currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') ? (
						<StatisticsAdmin />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/statistics/today'
				element={
					currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') &&
					currentUser.permission.includes('seeAllStoresStatistics') ? (
						<StatisticsAdminToday />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/statistics/store/:storeId'
				element={
					currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') ? (
						<StatisticsByStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/statistics/store/today/:storeId'
				element={
					currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') &&
					currentUser.permission.includes('seeAllStoresStatistics') ? (
						<StatisticsTodayByStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/statistics/user'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('seeRevenue') ? <UserStatistics /> : <SignIn />
				}
			/>
			<Route
				path='/admin/statistics/user/:storeId'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('seeRevenue') ? <Statistics /> : <SignIn />
				}
			/>
			<Route
				path='/admin/stock'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageStock') ? <StockManagement /> : <SignIn />
				}
			/>
			<Route
				path='/admin/bill'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageBill') ? <BillManagement /> : <SignIn />
				}
			/>
			<Route
				path='/admin/bill-list/:storeId'
				element={currentUser.isLoggedIn && currentUser.permission?.includes('manageBill') ? <BillList /> : <SignIn />}
			/>
			<Route
				path='/admin/bill/:storeId'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageBill') ? (
						<ImportStockBillByStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/bill-review/:storeId'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageBill') ? (
						<StockBillDetailByStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/bill-detail/:billCode'
				element={currentUser.isLoggedIn && currentUser.permission?.includes('manageBill') ? <BillDetail /> : <SignIn />}
			/>
			<Route
				path='/admin/stock/forecast'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('seeStockForecast') ? (
						<StockForecast />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/stock/statistics'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('seeAllStoresStockStatistics') ? (
						<StockStatistics />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/stock/statistics/:storeId'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('seeAllStoresStockStatistics') ? (
						<StockStatisticsByStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/stock/history'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageStock') ? (
						<ImportExportHistory />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/stock/params'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageStock') ? <StockParameter /> : <SignIn />
				}
			/>
			<Route
				path='/admin/schedule'
				element={
					currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') ? (
						<ScheduleOrderManagement />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/guest-order'
				element={
					currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') ? (
						<GuestOrderManagement />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/admin/guest-order/store/:storeId'
				element={
					currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') ? (
						<GuestOrderByStore />
					) : (
						<SignIn />
					)
				}
			/>

			<Route path='/warehouse-management/*' element={<WarehouseRouter />} />

			<Route
				path='/store-manager'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageStockByStore') ? (
						<StoreManagerOptions />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/users'
				element={currentUser.isLoggedIn && currentUser.role === 'storeManager' ? <UserManagementSM /> : <SignIn />}
			/>
			<Route
				path='/store-manager/signup-user'
				element={currentUser.isLoggedIn && currentUser.role === 'storeManager' ? <SignUpUserSM /> : <SignIn />}
			/>
			<Route
				path='/store-manager/edit-user/:userId'
				element={currentUser.isLoggedIn && currentUser.role === 'storeManager' ? <EditUserSM /> : <SignIn />}
			/>
			<Route
				path='/store-manager/transfer-info'
				element={
					currentUser.isLoggedIn && currentUser.permission.includes('updateTransferInfo') ? (
						<UpdateTransferInfo />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/statistics'
				element={
					currentUser.isLoggedIn && currentUser.permission.includes('seeStatisticsByStore') ? (
						<StatisticsSM />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/stock/statistics'
				element={
					currentUser.isLoggedIn && currentUser.permission.includes('seeStockStatisticsByStore') ? (
						<StockStatisticsByStoreSM />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/stock/fresh'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageStockByStore') ? (
						<StockManagementByStoreMultiPic />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/stock/history'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageStockByStore') ? (
						<ImportExportHistoryByStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/stock/history/:date'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('seeStockStatisticsByStore') ? (
						<ImportExportHistoryByStoreByDate />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/check-fresh-stock/history/:date'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('seeStockStatisticsByStore') ? (
						<CheckFreshStockHistory />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/check-product-stock/history/:date'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('seeStockStatisticsByStore') ? (
						<CheckProductStockHistory />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/stock/product'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageStockByStore') ? (
						<ProductStockMultiPic />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/stock/confirm'
				element={
					currentUser.isLoggedIn &&
					(currentUser.permission?.includes('confirmSellExport') ||
						currentUser.permission?.includes('confirmReImportFresh') ||
						currentUser.permission?.includes('confirmReImportCooked')) ? (
						<ConfirmStockMultiPic />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/stock/view-history'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('viewStockHistory') ? (
						<ViewStockHistory />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/stock/params'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageStockByStore') ? (
						<StockParameterByStore />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/statistics/today'
				element={
					currentUser.isLoggedIn && currentUser.permission.includes('seeStatisticsByStore') ? (
						<StatisticsSMToday />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/guest-order'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageGuestOrder') ? <GuestOrder /> : <SignIn />
				}
			/>
			<Route
				path='/store-manager/shipping-service'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageShippingService') ? (
						<ShippingService />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/shipping-service-order'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageShippingServiceOrder') ? (
						<ShippingServiceOrder />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/store-manager/statistics/transfer-order'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('transferStore') ? (
						<TransferOrderStatistics />
					) : (
						<SignIn />
					)
				}
			/>

			<Route path='/user/profile' element={currentUser.isLoggedIn ? <UserProfile /> : <SignIn />} />
			<Route
				path='/cashflow'
				element={
					canAccessCashflow(currentUser) ? (
						<Cashflow />
					) : (
						<SignIn />
					)
				}
			/>
			<Route path='/user/edit-profile' element={currentUser.isLoggedIn ? <EditProfile /> : <SignIn />} />
			<Route path='/user/task' element={currentUser.isLoggedIn ? <UserTask /> : <SignIn />} />
			<Route
				path='/user/internal-sale'
				element={
					currentUser.isLoggedIn && currentUser.role !== 'staff' ? (
						<InternalSale />
					) : (
						<SignIn />
					)
				}
			/>
			<Route
				path='/user/statistics'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('seeRevenue') ? <Statistics /> : <SignIn />
				}
			/>
			<Route path='/user/search/:phone' element={currentUser.isLoggedIn ? <Search /> : <SignIn />} />
			<Route path='/user/search/detail/:orderId' element={currentUser.isLoggedIn ? <SearchDetail /> : <SignIn />} />
			<Route
				path='/user/search/timer-detail/:orderId'
				element={currentUser.isLoggedIn ? <SearchTimerDetail /> : <SignIn />}
			/>
			<Route
				path='/user/search/deleted-detail/:orderId'
				element={currentUser.isLoggedIn ? <SearchDeletedDetail /> : <SignIn />}
			/>
			<Route
				path='/user/search/guest-detail/:orderId'
				element={currentUser.isLoggedIn ? <SearchGuestDetail /> : <SignIn />}
			/>
			<Route
				path='/user/schedule/store/:storeId'
				element={currentUser.isLoggedIn ? <ScheduleOrderByStore /> : <SignIn />}
			/>
			<Route
				path='/admin/zalo-miniapp'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <ZaloMiniApp /> : <SignIn />}
			/>
			<Route
				path='/admin/zalo-mini-app/product'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <Product /> : <SignIn />}
			/>
			<Route
				path='/admin/zalo-mini-app/product/:id'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <DetailProduct /> : <SignIn />}
			/>
			<Route
				path='/admin/zalo-mini-app/product/create'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <CreateProduct /> : <SignIn />}
			/>
			<Route
				path='/admin/zalo-mini-app/product/edit/:id'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <EditProduct /> : <SignIn />}
			/>
			<Route
				path='/admin/zalo-mini-app/config'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <Configuration /> : <SignIn />}
			/>
			<Route
				path='/admin/zalo-mini-app/customer'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <Customer /> : <SignIn />}
			/>
			<Route path='/admin/zalo-mini-app/customer/:id' element={<CustomerDetail />} />
			<Route
				path='/admin/zalo-mini-app/statistics'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <ZaloStatistics /> : <SignIn />}
			/>
			<Route
				path='/admin/zalo-mini-app/customer/:id/customer-history-points'
				element={currentUser.isLoggedIn && currentUser.role === 'admin' ? <CustomerHistoryPoints /> : <SignIn />}
			/>

			<Route
				path='/store-manager/stock/:type'
				element={
					currentUser.isLoggedIn && currentUser.permission?.includes('manageStockByStore') ? (
						<ProductStockManagement />
					) : (
						<SignIn />
					)
				}
			/>
			<Route path='/admin/zalo-mini-app/orders/:id' element={<Orders />} />
			<Route path='/admin/zalo-mini-app/order-detail/:orderId' element={<OrderDetail />} />
		</Routes>
	)
}

export default App
